import script from "./ContactPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ContactPopup.vue?vue&type=style&index=0&id=67b20f9e&lang=scss"

const __exports__ = script;

export default __exports__